/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ACHTokenDetails } from '../models/ACHTokenDetails';
import type { ACHTokenUpdateModel } from '../models/ACHTokenUpdateModel';
import type { IvrPayRequest } from '../models/IvrPayRequest';
import type { PaceUrlOptions } from '../models/PaceUrlOptions';
import type { TokenCreateModel } from '../models/TokenCreateModel';
import type { TokenPaymentCreate } from '../models/TokenPaymentCreate';
import type { TransactionDetails } from '../models/TransactionDetails';
import { request as __request } from '../core/request';

export class AchTokensVService {

    /**
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static async achTokensVGetAchTokenUrl(
        requestBody?: PaceUrlOptions,
    ): Promise<string> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/tokens/ach/url-form`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns ACHTokenDetails Created
     * @throws ApiError
     */
    public static async achTokensVCreateAchToken(
        requestBody?: TokenCreateModel,
    ): Promise<ACHTokenDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/tokens/ach/create`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param tokenId
     * @param requestBody
     * @returns TransactionDetails Created
     * @throws ApiError
     */
    public static async achTokensVCharge(
        tokenId: string,
        requestBody?: TokenPaymentCreate,
    ): Promise<TransactionDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/tokens/ach/${tokenId}/charge`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param tokenId
     * @param requestBody
     * @returns ACHTokenDetails OK
     * @throws ApiError
     */
    public static async achTokensVUpdateAch(
        tokenId: string,
        requestBody?: ACHTokenUpdateModel,
    ): Promise<ACHTokenDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v3/tokens/ach/${tokenId}`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns TransactionDetails Created
     * @throws ApiError
     */
    public static async achTokensVIvrCharge(
        requestBody?: IvrPayRequest,
    ): Promise<TransactionDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v3/tokens/ach/ivr/charge`,
            body: requestBody,
        });
        return result.body;
    }

}